<script>
import Validation from '@/plugins/validation'
import { InputWithObj, Select } from '@/components/formelements'
import { mapState, mapGetters } from 'vuex'

export default {
  name: 'Site',
  props: ['id', 'siteid'],
  async mounted() {
    this.$store.dispatch('site/RESET')
    if (this.id == 0) this.$store.dispatch('retailer/RESET')
    await this.$store.dispatch('site/SET_SITE', { retailerID: this.id, siteID: this.siteid })
    if (this.id != 0) await this.$store.dispatch('site/GET_PRETAILER')
    this.tableOneLoad = false
  },
  data() {
    return {
      ...Validation,
      dialog: false,
      siteGroupView: false,
      tableOneLoad: true,
      tableTwoLoad: true,
      clickedPretailer: {},
      viewPromoTypes: true
    }
  },
  components: {
    InputWithObj,
    Select,
  },
  computed: {
    ...mapState({
      orgRetailerInfo: state => state.retailer.orgRetailerInfo,
      siteTypes: state => state.siteFilter.siteTypes,
      siteInfo: state => state.site.siteInfo,
      statusTypes: state => state.search.statusTypes,
      siteTableHeaders: state => state.site.headers
    }),
    ...mapGetters({
      pretailers: 'site/pretailers',
      siteGroup: 'site/siteGroup',
      promotionTypes: 'site/promotionType',
      promotions: 'site/promotions',
      promoChildTypes: 'siteFilter/promoChildTypes',
    }),
    getRowStatus: function() {
      if (!this.siteInfo.RowStatus) return 'Active'
      const status = this.statusTypes.filter( type => type.ID == this.siteInfo.RowStatus )
      return status[0].Name
    },
    siteTypeItems: function() {
      const eligibleSiteTypes =  this.siteTypes.filter( type => type.EligibleForRetailer == "true")
      return eligibleSiteTypes.map( type => {
        return { text: type.Name, value: type.ID }
      })
    },
  },
  methods: {
    siteGroupHeaders() {
      return [
        {
          text: 'Attached',
          value: 'IsAttachedToSite'
        },
        {
          text: 'Site Group Name',
          value: 'Name'
        },
        {
          text: 'Type',
          value: 'TypeID'
        }
      ]
    },
    promotionTypeHeaders() {
      return [
        {
          text: 'Attached',
          value: 'IsAttachedToSite'
        },
        {
          text: 'Type ID',
          value: 'ID'
        },
        {
          text: 'Description',
          value: 'Description'
        }
      ]
    },
    promotionHeaders() {
      return [
        {
          text: 'Attached',
          value: 'IsAttachedToSite'
        },
        {
          text: 'Promotion Code',
          value: 'Code'
        },
        {
          text: 'Start Date',
          value: 'PostStartDate'
        },
        {
          text: 'End Date',
          value: 'PostEndDate'
        },        
        {
          text: 'Promotion Type',
          value: 'PromotionTypeDescription'
        },
        {
          text: 'Promotion Group',
          value: 'PromotionGroupName'
        },                
      ]
    },
    typeID(id){
      const type = this.siteTypes.filter( type => type.ID == id)
      return type[0].Name
    },
    async checkboxClick(item) {
      const status = function(){
        if (item.IsAttachedToSite == false) return 1
        return 901
      }
      await this.$store.dispatch('site/ATTACH_DETACH_PRETAILER', { pretailerID: item.ID, rowStatusTypeID: status() })
    },
    async siteCheckboxClick(item){
      const status = function(){
        if (item.IsAttachedToSite == false) return 1
        return 901
      }
      await this.$store.dispatch('site/ATTACH_DETACH_SITE_GROUP', { siteGroupId: item.ID, rowStatus: status() })
    },
    async getSiteGroups(){
      this.siteGroupView = !this.siteGroupView 
      if (this.siteGroup.length == 0){
        await this.$store.dispatch('site/GET_SITE_GROUP', this.siteid)
        this.tableTwoLoad = false
      }
    },
    async rowClick(e, {item}){
      this.clickedPretailer = item
      await this.$store.dispatch('site/GET_SITE_PRETAILER_PROMO_TYPES', { pRetailer: item.ID, siteID: this.siteid})
      this.dialog = true
    },
    async updatedPromotionType(item) {
      const status = function(){
        if (item.IsAttachedToSite == false) return 1
        return 901
      }
      await this.$store.dispatch('site/ATTACH_DETACH_PROMO_TYPE', { promotionTypeID: item.ID, pretailerID: this.clickedPretailer.ID ,rowStatusTypeID: status() })
    },
    async updatedPromotion(item) {
      const status = function(){
        if (item.IsAttachedToSite == false) return 1
        return 901
      }
      await this.$store.dispatch('site/ATTACH_DETACH_PROMO', { promotionCode: item.Code, pretailerID: this.clickedPretailer.ID ,rowStatusTypeID: status() })
    },    
    async getPromos(){
      this.viewPromoTypes = !this.viewPromoTypes 
      if (this.promotions.length == 0){
        await this.$store.dispatch('site/GET_SITE_PROMO', { siteID: this.siteid, pretailerID: this.clickedPretailer.ID})
      }
    },
    async updateSite(){
      if(this.$refs.siteForm.validate()){
        await this.$store.dispatch('site/UPDATE_SITE')
      }
    }
  }
}
</script>

<template>
  <v-container fluid>
    <v-row v-if="id != 0">
      <router-link style="text-decoration: none" class="px-5 pb-5" :to="{ name: 'Retailer', params: { id: id } }"> 
        Retailer: {{ orgRetailerInfo.Name }} ({{ id }}) 
      </router-link>
    </v-row>
    <v-form ref="siteForm">
      <v-row>
        <v-col cols="6">
          Site ID: {{ siteInfo.ID }}
        </v-col>
        <v-col cols="6">
          Row Status: <span :class="{ 'green--text font-weight-black': siteInfo.RowStatus == 1 || siteInfo.RowStatus == undefined }">{{ getRowStatus }}</span>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" md="6">
          <InputWithObj :rules="[...required]" form="site" field="siteInfo" objkey="Code" label="Site Code"/>
        </v-col>
        <v-col cols="12" md="6">
          <InputWithObj form="site" field="siteInfo" objkey="Description" label="Site Description" />
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" md="6">
          <Select readonly form="site" field="siteInfo" objkey="TypeID" :items="siteTypeItems" placeholder="" label="Site Type" />  
        </v-col>
        <v-col cols="12" md="6">
          <Select form="site" field="siteInfo" objkey="DefaultPromotionChildTypeID" :items="promoChildTypes" placeholder="" label="Default Promotion Code" />  
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="6">
          Last Updated By<br/> {{ siteInfo.LastUpdatedBy }}
        </v-col>
        <v-col cols="6">
          Last Updated Date<br/> {{ siteInfo.LastUpdateDate }}
        </v-col>
      </v-row>
      <v-row>
        <v-col class="d-flex justify-space-between" cols="12">
          <v-btn @click="updateSite" :disabled="!$store.getters['site/siteChanged']" width="125" color="primary">
            <v-icon left>mdi-content-save</v-icon>Save
          </v-btn>
          <v-btn v-if="!siteGroupView && id != 0" @click="getSiteGroups" color="primary">
            Site Groups
          </v-btn>
          <v-btn v-if="siteGroupView && id != 0" @click="siteGroupView = !siteGroupView" color="primary">
            PRetailer Membership
          </v-btn>
        </v-col>
      </v-row>
    </v-form>
    <v-row v-if="id != 0">
      <v-col v-if="!siteGroupView" cols="12">
        <h2 class="d-flex justify-center">Currently viewing PRetailer Membership</h2>
        <p class="d-flex justify-center primary--text">Double click Row to view/edit Promotion Type and Promotions</p>
        <v-data-table
          :headers="siteTableHeaders"
          :items="pretailers"
          :items-per-page="10"
          :loading="tableOneLoad"
          multi-sort
          sort-by="IsAttachedToSite"
          sort-desc
          @dblclick:row="rowClick"
        >
          <template v-slot:item.IsAttachedToSite=" { item }" >
            <span>
              <v-simple-checkbox 
                style="width: 25px;"
                @click.capture="checkboxClick(item)"
                color="primary"
                :ripple="false"
                :value="item.IsAttachedToSite"
              ></v-simple-checkbox>
            </span>
          </template>
        </v-data-table>
      </v-col>
      <v-col v-else>
        <h2 class="d-flex justify-center">Currently viewing Site Group Membership</h2>
        <v-data-table
          :headers="siteGroupHeaders()"
          :items="siteGroup"
          :items-per-page="10"
          :loading="tableTwoLoad"
          multi-sort
          sort-by="IsAttachedToSite"
          sort-desc
        >
          <template v-slot:item.IsAttachedToSite=" { item }" >
            <span>
              <v-simple-checkbox 
                @click.capture="siteCheckboxClick(item)"
                color="primary"
                :ripple="false"
                :value="item.IsAttachedToSite"
              ></v-simple-checkbox>
            </span>
          </template>
          <template v-slot:item.TypeID=" { item }" >
            <span>
              {{ typeID(item.TypeID) }}
            </span>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
    <v-dialog persistent v-model="dialog" width="800">
      <v-card>
        <v-card-title class="primary--text">
          Pretailer: {{ clickedPretailer.Name}}({{ clickedPretailer.ID }}) <v-btn v-if="viewPromoTypes" @click="getPromos" depressed class="ml-3" color="primary">Promotion</v-btn><v-btn v-else @click="viewPromoTypes = !viewPromoTypes" depressed class="ml-3" color="primary">Promotion Type</v-btn>
        </v-card-title>
        <v-card-text v-if="viewPromoTypes">
          <h2>Current viewing Promotion Types</h2>
          <v-data-table
            :headers="promotionTypeHeaders()"
            :items="promotionTypes"
            :items-per-page="10"
            multi-sort
            sort-by="IsAttachedToSite"
            sort-desc
          >
            <template v-slot:item.IsAttachedToSite=" { item }" >
              <span>
                <v-simple-checkbox 
                  @click.capture="updatedPromotionType(item)"
                  color="primary"
                  :ripple="false"
                  :value="item.IsAttachedToSite"
                ></v-simple-checkbox>
              </span>
            </template>
          </v-data-table>
        </v-card-text>
        <v-card-text v-else>
          <h2>Current viewing Promotions</h2>
          <v-data-table
            :headers="promotionHeaders()"
            :items="promotions"
            :items-per-page="10"
            multi-sort
            sort-by="IsAttachedToSite"
            sort-desc
          >
            <template v-slot:item.IsAttachedToSite=" { item }" >
              <span>
                <v-simple-checkbox 
                  @click.capture="updatedPromotion(item)"
                  color="primary"
                  :ripple="false"
                  :value="item.IsAttachedToSite"
                ></v-simple-checkbox>
              </span>
            </template>
          </v-data-table>
        </v-card-text>
        <v-card-actions class="d-flex justify-end px-5 pb-5">
          <v-btn @click="dialog = false" color="secondary">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>
